import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://monevenemenciel.eu';
const DEFAULT_IMAGE = '/img/photo-accueil-mon-evenemenciel.webp';

const toAbsoluteUrl = (pathOrUrl) => {
  if (!pathOrUrl) return `${BASE_URL}${DEFAULT_IMAGE}`;
  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) {
    return pathOrUrl;
  }
  return `${BASE_URL}${pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`}`;
};

const SEO = ({
  title,
  description,
  keywords,
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
}) => {
  const siteTitle = 'Mon Evénemenciel';
  const fullTitle = title
    ? `${title} | ${siteTitle}`
    : `${siteTitle} | L'art de vous rassembler`;
  const defaultDescription =
    "Mon Evénemenciel, votre partenaire événementiel en entreprise. Afterworks, team building, séminaires et animations sur mesure à Lyon et en France.";
  const metaDescription = description || defaultDescription;
  const defaultKeywords =
    'événementiel entreprise, team building Lyon, afterwork entreprise, séminaire Lyon, animation entreprise, Mon Evénemenciel';
  const metaKeywords = keywords || defaultKeywords;
  const pageUrl = url === '/' || !url ? `${BASE_URL}/` : `${BASE_URL}${url}`;
  const absoluteImage = toAbsoluteUrl(image);
  // Prefer .webp for social cards when a .jpg/.png path is passed
  const socialImage = absoluteImage.replace(/\.(jpe?g|png)$/i, '.webp');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <link rel="canonical" href={pageUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={socialImage} />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content={siteTitle} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={socialImage} />
    </Helmet>
  );
};

export default SEO;
